var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout"},[_c('header-client-view'),_c('main',{staticClass:"main",class:{ 'expanded-navbar': _vm.addMarginToMain }},[_vm._t("default")],2),_c('footer-client-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }